import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileCollectorHelpFindAndSelectPage() {
  const t = useTranslations('collectors_help.find_and_select');
  const [openSections, setOpenSections] = useState({
    everythingPurchase: false,
    tipsPerfectArtwork: false,
    searchFilters: false,
    following: false,
    exploringFeatures: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/collector-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('everythingPurchase')}
            aria-expanded={openSections.everythingPurchase}
          >
            <h2>{t('sections.everything_purchase.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.everythingPurchase ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.everythingPurchase && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.everything_purchase.p1')}</p>
              <p>{t('sections.everything_purchase.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('tipsPerfectArtwork')}
            aria-expanded={openSections.tipsPerfectArtwork}
          >
            <h2>{t('sections.tips_perfect_artwork.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.tipsPerfectArtwork ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.tipsPerfectArtwork && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.tips_perfect_artwork.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.tips_perfect_artwork.home_title')}</h3>
                <p>{t('sections.tips_perfect_artwork.home_p1')}</p>
                <p>{t('sections.tips_perfect_artwork.home_media')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.tips_perfect_artwork.suarteworld_title')}</h3>
                <p>{t('sections.tips_perfect_artwork.suarteworld_p1')}</p>
                <p>{t('sections.tips_perfect_artwork.suarteworld_media')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.tips_perfect_artwork.search_title')}</h3>
                <p>{t('sections.tips_perfect_artwork.search_p1')}</p>
                <p>{t('sections.tips_perfect_artwork.search_media')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('searchFilters')}
            aria-expanded={openSections.searchFilters}
          >
            <h2>{t('sections.search_filters.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.searchFilters ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.searchFilters && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.search_filters.p1')}</p>
              <p>{t('sections.search_filters.p2')}</p>
              <ul>
                <li>{t('sections.search_filters.list_1')}</li>
                <li>{t('sections.search_filters.list_2')}</li>
                <li>{t('sections.search_filters.list_3')}</li>
                <li>{t('sections.search_filters.list_4')}</li>
                <li>{t('sections.search_filters.list_5')}</li>
              </ul>

              <div className="artist-help-category__note">
                <h3>{t('sections.search_filters.tip_title')}</h3>
                <p>{t('sections.search_filters.tip_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('following')}
            aria-expanded={openSections.following}
          >
            <h2>{t('sections.following.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.following ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.following && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.following.p1')}</p>
              <ul>
                <li>{t('sections.following.list_1')}</li>
                <li>{t('sections.following.list_2')}</li>
                <li>{t('sections.following.list_3')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('exploringFeatures')}
            aria-expanded={openSections.exploringFeatures}
          >
            <h2>{t('sections.exploring_features.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.exploringFeatures ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.exploringFeatures && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.exploring_features.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.sea_title')}</h3>
                <p>{t('sections.exploring_features.sea_p1')}</p>
                <p>{t('sections.exploring_features.sea_p2')}</p>
                <ul>
                  <li>{t('sections.exploring_features.sea_list_1')}</li>
                  <li>{t('sections.exploring_features.sea_list_2')}</li>
                  <li>{t('sections.exploring_features.sea_list_3')}</li>
                  <li>{t('sections.exploring_features.sea_list_4')}</li>
                </ul>
                <p>{t('sections.exploring_features.sea_p3')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.thoughts_title')}</h3>
                <p>{t('sections.exploring_features.thoughts_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.posts_title')}</h3>
                <p>{t('sections.exploring_features.posts_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.ratings_title')}</h3>
                <p>{t('sections.exploring_features.ratings_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.artlists_title')}</h3>
                <p>{t('sections.exploring_features.artlists_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.suarteworld_title')}</h3>
                <p>{t('sections.exploring_features.suarteworld_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.community_title')}</h3>
                <p>{t('sections.exploring_features.community_p1')}</p>
                <p>{t('sections.exploring_features.community_p2')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.art_games_title')}</h3>
                <p>{t('sections.exploring_features.art_games_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.story_told_title')}</h3>
                <p>{t('sections.exploring_features.story_told_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.likes_title')}</h3>
                <p>{t('sections.exploring_features.likes_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.inspiring_title')}</h3>
                <p>{t('sections.exploring_features.inspiring_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.rankings_title')}</h3>
                <p>{t('sections.exploring_features.rankings_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.mode_theme_title')}</h3>
                <p>{t('sections.exploring_features.mode_theme_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.exploring_features.suarte_plus_title')}</h3>
                <p>{t('sections.exploring_features.suarte_plus_p1')}</p>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.exploring_features.community_note_title')}</h3>
                <p>{t('sections.exploring_features.community_note_p1')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
